const menu = [
    {
      id: 1,
      category: 'Full-stack',
      img: './imagesProjet/react-redux.jpg',
    },
    {
      id: 2,
      category: 'Mobile',
      img: './imagesProjet/react-native.jpg',
    },
    {
      id: 3,
      category: 'Front-End',
      img: './imagesProjet/bootstrap.jpg',
    },
    {
      id: 4,
      category: 'Full-stack',
      img: './imagesProjet/htmlcss.jpg',
    },
    {
      id: 5,
      category: 'Mobile',
      img: './imagesProjet/application.jpg',
    },
    {
      id: 6,
      category: 'Front-End',
      img: './imagesProjet/htmlcss.jpg',
    },
    {
      id: 7,
      category: 'Full-stack',
      img: './imagesProjet/e-commerce.jpg',
    },
    {
      id: 8,
      category: 'Mobile',
      img: './imagesProjet/react-native.jpg',
    },
    {
      id: 9,
      category: 'Front-End',
      img: './imagesProjet/angularjs.jpg',
    },
  ];
  export default menu;